module.exports = require("core-js/modules/web.dom-collections.iterator.js");